import React from 'react'
import { css } from 'helpers'
import Add from '@material-ui/icons/Add'

class UploadFile extends React.Component {
  state = {
    display: 'none'
  }

  handleFileSelect = event => {
    const { payload, postImage, onSuccess, onFailure } = this.props

    const file = event.target.files[0]

    let data = new FormData()
    payload.forEach(object => {
      data?.append(object.name, object.value)
    })
    data?.append('file', file)

    postImage(data)
      .then(response => {
        if (onSuccess) {
          onSuccess(response)
        }
      })
      .catch(error => {
        if (onFailure) {
          onFailure(error)
        }
      })

    this.uploadFile.value = null
  }

  render() {
    const { display } = this.state
    const { accept, image } = this.props
    return (
      <div
        className={css({
          position: 'relative',
          cursor: 'pointer',
          borderRadius: '50%'
        })}
        onMouseEnter={() => this.setState({ display: 'flex' })}
        onMouseLeave={() => this.setState({ display: 'none' })}
        onClick={() => this.uploadFile.click()}
      >
        {image && (
          <div
            className={css({
              display,
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              borderRadius: '50%',
              backgroundColor: 'rgba(0,0,0,0.4)'
            })}
          >
            <Add style={{ color: 'white', fontSize: 32 }} />
          </div>
        )}
        <input
          type="file"
          accept={accept ? accept : 'image/*'}
          style={{ display: 'none' }}
          ref={upload => (this.uploadFile = upload)}
          onChange={this.handleFileSelect}
        />
        {this.props.children}
      </div>
    )
  }
}

export default UploadFile
